import { useTranslation } from 'react-i18next';

import { useSbkBetSlipStore } from '@/feature/betslip-sbk/hooks/use-sbk-betslip-store';
import { BetTypes } from '@/feature/betslip-sbk/types';
import { isOptionSuspended, isProducerDown } from '@/utils/option-status';

import { WarningBanner } from './WarningBanner';

export const SuspendedWarning = () => {
    const { t } = useTranslation('betslip_sbk');

    const hasSuspendedStakedBet = useSbkBetSlipStore(state => {
        return Object.values(state.bets).some(bet => {
            if (!bet.stake || bet.betType !== BetTypes.Single) {
                return false;
            }
            const option = state.options[bet.id];
            const market = state.markets[option?.marketId];
            const optionStatus = option?.status ?? 'SUSPENDED';
            const producerDown = isProducerDown(state.producerStatuses, market?.supplier);
            return isOptionSuspended(optionStatus, producerDown, market?.published ?? false);
        });
    });

    if (!hasSuspendedStakedBet) {
        return null;
    }

    return <WarningBanner message={t('suspended_picks_warning')} />;
};
